/**
How to add a new form for a data structure:
Create forms/NameForm.tsx
Call registerForm("Name", NameForm) at the end of the file. The name must match the data structure name.
Import in Forms/index.ts
 */

import { ComponentType } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface DataStructureFormProps<T = any> {
  playerId: string;
  data: T;
  onSave: (data: T) => Promise<boolean>;
  onCancel: () => void;
}

type FormComponent = ComponentType<DataStructureFormProps>;

const formRegistry: Record<string, FormComponent> = {};

export const registerForm = (dataStructureName: string, component: FormComponent) => {
  formRegistry[dataStructureName] = component;
};

export const getFormComponent = (dataStructureName: string): FormComponent | null => {
  return formRegistry[dataStructureName] || null;
};

export const hasFormComponent = (dataStructureName: string): boolean => {
  return dataStructureName in formRegistry;
};
